#import "./AssetFields.graphql"

mutation DeleteAssetDocument($id: ID!) {
  deleteAssetDocument(input: { id: $id }) {
    asset {
      ...AssetFields
    }
  }
}
